'use strict';

exports.__esModule = true;

var _webUtils = require('@vezeeta/web-utils');

var language = void 0;
if (_webUtils.Cookie.get(_webUtils.Cookie.LANGUAGE)) {
  language = _webUtils.Cookie.get(_webUtils.Cookie.LANGUAGE);
} else {
  _webUtils.Cookie.set(_webUtils.Cookie.LANGUAGE, 'en');
  language = 'en';
}

exports.default = {
  language: language
};
module.exports = exports['default'];